import React, { FC, useState, useEffect } from 'react';
import './../static/styles/identityAuthenticationFailed.scss';

interface Props {
  url: string;
  onClose: () => void;
}

const IdentityAuthenticationFailed: FC<Props> = (props) => {

  const confirm = () => {
    props.onClose && props.onClose();
  }
  
  return (
    <div className='identity-authentication-failed__layer'>
      <div className='identity-authentication-failed__dialog'>
        <div className='identity-authentication-failed__hd'>      您的投保人身份认证未通过，根据深圳监管要求，请通过浏览器打开下述链接完成投保人身份认证：</div>
        <div className='identity-authentication-failed__bd'>{props.url}</div>
        <div className='identity-authentication-failed__ft' onClick={confirm}>确认</div>
      </div>
    </div>
  )
  
}

export default IdentityAuthenticationFailed;